import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import withPermissions from "permissions/withPermissions";
import DefaultPageLayout from "components/layouts/default-page-layout";
import { useSelector } from "react-redux";
import { getSignedInOrgUnit } from "app/auth/store/reducers/user.reducer";
import { formatUtcDate } from "helpers/format-date-time";
import UserImportLogDetailsTable from "../components/user-import-log-details-table";

const UserImportLogDetailsPage = ({
  hasPermissionBulkUserImportLogView,
  match: { params: { logId } },
}) => {
  const signedInOrgUnit = useSelector(getSignedInOrgUnit);
  const location = useLocation();
  const { fileName, uploadedDateTime } = location.state || {};

  const headerContent = fileName && uploadedDateTime && (
    <Box mt={3} mb={2} px={3}>
      <Typography variant="h6">{fileName}</Typography>
      <Typography variant="body2" color="textSecondary">
        Uploaded: {formatUtcDate(uploadedDateTime, "DD-MMM-YY HH:mm")}
      </Typography>
    </Box>
  );

  return (
    <DefaultPageLayout
      accessDenied={!hasPermissionBulkUserImportLogView}
      header={headerContent}
      content={(
        <UserImportLogDetailsTable orgUnitId={signedInOrgUnit.id} importLogId={logId} />
      )}
    />
  );
};

export default withPermissions("BulkUserImportLogView")(UserImportLogDetailsPage);
